import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TimeZone } from '../../../pages/admin/timezones/timezone-interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesApi {
  private http = inject(HttpClient);

  fetchTimezones(): Observable<TimeZone[]> {
    return this.http.get<TimeZone[]>(`service/timezones/user`);
  }
}
